import Star from "react-feather/dist/icons/star";

import style from "./style.module.scss";

interface Testimonial {
  name: string;
  text: string;
}

const testimonials: Testimonial[] = [
  {
    name: "Chahinez",
    text: "Je viens de retomber sur le book que vous m'aviez fait. C'est vraiment du beau travail!",
  },
  {
    name: "Manel",
    text: "Magnifique, j'adore le résultat et bonne continuation.",
  },
  {
    name: "Doria",
    text: "J'ai créé mon livre photos personnalisé de mes vacances. Je l'ai reçu rapidement. Très satisfaite de la qualité!",
  },
];

// Double the testimonials for seamless marquee loop
const marqueeItems = [...testimonials, ...testimonials];

function TestimonialCard({ testimonial }: { testimonial: Testimonial }) {
  return (
    <div className={style.testimonialCard}>
      <span className={style.testimonialQuote}>&ldquo;</span>
      <p className={style.testimonialText}>{testimonial.text}</p>
      <div className={style.testimonialFooter}>
        <div className={style.testimonialStars}>
          {[...Array(5)].map((_, i) => (
            <Star key={i} className={style.starIcon} />
          ))}
        </div>
        <p className={style.testimonialName}>{testimonial.name}</p>
      </div>
    </div>
  );
}

function TestimonialsSection() {
  return (
    <section className={style.testimonials}>
      <h2 className={style.testimonialsTitle}>Ce que nos clients disent</h2>
      <div className={style.marqueeWrap}>
        <div className={style.marqueeTrack}>
          {marqueeItems.map((testimonial, index) => (
            <TestimonialCard key={index} testimonial={testimonial} />
          ))}
        </div>
      </div>
      <div className={style.marqueeWrap}>
        <div className={style.marqueeTrackReverse}>
          {marqueeItems.map((testimonial, index) => (
            <TestimonialCard key={index} testimonial={testimonial} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default TestimonialsSection;
